module.exports = __webpack_public_path__ + "static/media/52 - Logo Himpunan Mahasiswa Manajemen Bisnis ITS.a4d78590.jpg";